var render = function render(_c,_vm){return _c('div',{staticClass:"grid-view__cell",class:_vm.data.staticClass || ''},[_c('div',{staticClass:"grid-field-boolean"},[_c('div',{staticClass:"grid-field-boolean__checkbox",class:{ active: _vm.props.value }},[_c('i',{staticClass:"iconoir-check grid-field-boolean__checkbox-icon"})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }